import React, { useState } from 'react';
import myWorks from '../utils/MyWorksDB';
import '../custom-scroll-bar.css';
import { Link } from 'react-router-dom';

// ==========================================
// EDIT YOUR TEXTS AND DATA HERE
// Note: To edit the actual games in the list, 
// open the file: src/utils/MyWorksDB.js
// ==========================================
const MY_WORKS_DATA = {
  heading: "My Games",
  buttonTextShowMore: "Show More ↓",
  buttonTextShowLess: "Show Less ↑",
  initialVisibleCount: 4
};
// ==========================================

const MyWorks = () => {
  const [showAll, setShowAll] = useState(false);

  // Determine which works to show based on state
  const displayedWorks = showAll ? myWorks : myWorks.slice(0, MY_WORKS_DATA.initialVisibleCount);
  return (
    <div className='p-4 mt-8 w-full overflow-hidden'>
      <div className="w-full md:max-w-4xl lg:max-w-[110rem] mx-auto bg-fgPurple rounded-2xl border-4 border-black p-6" style={{ boxShadow: '5px -5px 0px 0px black' }} id="my-works-section">
        <div className='inline-block mb-4'>
          <div className="bg-fgYellow rounded-2xl shadow-md border-4 border-black py-4 px-12" style={{ boxShadow: '-3px 3px 0px 0px black' }}>
            <h2 className=" text-lg md:text-3xl text-center font-semibold">{MY_WORKS_DATA.heading}</h2>
          </div>
        </div>

        {/* Animated Wrapper for the Responsive Grid */}
        <div
          className="transition-all duration-700 ease-in-out overflow-hidden"
          style={{
            // 480px comfortably covers 1 row of cards + padding. 4000px allows room for all rows when expanded.
            maxHeight: showAll ? '4000px' : '450px',
            opacity: showAll ? 1 : 0.95
          }}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-8 pb-4">
            {myWorks.map((work) => (
              <div key={work.id} className="bg-white rounded-[1.3rem] shadow-md border-4 border-black p-3 flex flex-col relative w-full h-full">
                {/* Fixed Layout for Title, Price, and Avatar with a Rounded Ribbon Background */}
                <div className="flex items-center space-x-3 w-full mb-3 z-10 bg-fgYellow rounded-xl border-2 border-black p-1 shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] pr-4">
                  <img src={work.avatarImg} alt="Avatar" className="w-[45px] h-[45px] object-cover rounded-full flex-shrink-0 border-2 border-black bg-white" />
                  <div className="flex flex-col flex-grow justify-center pb-1">
                    <h3 className="text-black text-base md:text-lg font-bold font-clash-display-semibold leading-tight">{work.title}</h3>
                    <p className="text-gray-800 text-sm font-clash-display-medium leading-tight">{work.price}</p>
                  </div>
                </div>
                <div className="flex-grow relative mt-2 flex flex-col items-center">
                  <img src={work.gameImg} alt="Game" className="w-full h-48 md:h-56 object-cover mb-4 rounded-xl border-2 border-black shadow-[2px_2px_0px_0px_rgba(0,0,0,1)]" />
                  <Link to={`/contribution${work.id}`} className="mt-auto mb-2 w-3/4">
                    <div className={`w-full bg-fgPink text-white rounded-lg shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] border-2 border-black py-2 px-4 text-center hover:translate-y-1 transition-all cursor-pointer`}>
                      <p className={`text-sm md:text-base font-bold`}>{work.contributions}</p>
                    </div>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Show More / Show Less Button */}
        {myWorks.length > MY_WORKS_DATA.initialVisibleCount && (
          <div className="flex justify-center mt-6 mb-2">
            <button
              onClick={() => setShowAll(!showAll)}
              className="bg-fgYellow text-black font-clash-display-bold text-lg md:text-xl py-3 px-8 rounded-full border-2 border-black shadow-[3px_3px_0px_0px_rgba(0,0,0,1)] hover:translate-y-1 hover:shadow-[1px_1px_0px_0px_rgba(0,0,0,1)] transition-all"
            >
              {showAll ? MY_WORKS_DATA.buttonTextShowLess : MY_WORKS_DATA.buttonTextShowMore}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default MyWorks;